__turbopack_context__.v({
  "active": "_4OwRHG_active",
  "breakpointL": "_4OwRHG_breakpointL",
  "breakpointM": "_4OwRHG_breakpointM",
  "disabled": "_4OwRHG_disabled",
  "drawer": "_4OwRHG_drawer",
  "hasActiveSibling": "_4OwRHG_hasActiveSibling",
  "item": "_4OwRHG_item" + " " + __turbopack_context__.i(248112)["focusOutline"],
  "items": "_4OwRHG_items",
  "placeholderText": "_4OwRHG_placeholderText",
  "scrollableContainer": "_4OwRHG_scrollableContainer",
  "selectionText": "_4OwRHG_selectionText",
  "selectionTextWrapper": "_4OwRHG_selectionTextWrapper",
  "triggerIconAtL": "_4OwRHG_triggerIconAtL",
  "triggerIconAtM": "_4OwRHG_triggerIconAtM",
});
